import { connect } from "react-redux";
import EditConfig from "./editConfig";
import { bindActionCreators } from "redux";
import { userdropdown, approverdropdown, updateUserConfig, getAutofillUserData } from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    userdropdownlist : state.UserHelpdesk.userdropdown,
    approverdropdownlist : state.UserHelpdesk.approverdropdown,
    updateuserconfiglist : state.UserHelpdesk.updateuserconfig,
    getautofilldatalist : state.UserHelpdesk.getautofilldata
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userdropdown,
        approverdropdown,
        updateUserConfig,
        getAutofillUserData,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditConfig);